<template>
  <el-dialog title="修改密码" :close-on-click-modal="false" :visible.sync="innerVisible" width="400px">
    <el-form :model="passwordForm" :rules="passwordRules" ref="passwordForm" label-width="100px" size="small">
      <el-form-item label="原密码" prop="pw">
        <el-input style="width:250px;" type="password" v-model="passwordForm.pw" placeholder="填写原密码">
        </el-input>
      </el-form-item>
      <el-form-item label="新密码" prop="npw">
        <el-input style="width:250px;" type="password" v-model="passwordForm.npw" placeholder="填写新密码">
        </el-input>
      </el-form-item>
      <el-form-item label="确认密码" prop="npw1">
        <el-input style="width:250px;" type="password" v-model="passwordForm.npw1" placeholder="再次填写新密码">
        </el-input>
      </el-form-item>
      <div class="zj-form-bottom">
        <el-button size="small" @click="innerVisible = false">取消</el-button>
        <el-button size="small" type="primary" @click="onChangeClick">确认修改</el-button>
      </div>
    </el-form>
  </el-dialog>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      passwordForm: {
        userId: "",
        pw: "",
        npw: "",
        npw1: ""
      },
      passwordRules: {
        pw: [
          {
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error("请填写密码"));
              } else {
                callback();
              }
            },
            trigger: "change"
          }
        ],
        npw: [
          {
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error("请填写新密码"));
              } else if (value == this.passwordForm.pw) {
                callback(new Error("新密码与原始密码一致!"));
              } else if(value.length >= 40) {
                callback(new Error("密码长度过长"));
              } else {
                callback();
              }
            },
            trigger: "change"
          }
        ],
        npw1: [
          {
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error("请再次填写新密码"));
              } else if (value !== this.passwordForm.npw) {
                callback(new Error("两次填写的密码不一致!"));
              } else {
                callback();
              }
            },
            trigger: "change"
          }
        ]
      }
    }
  },
  computed: {
    innerVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    }
  },
  methods: {
    onChangeClick() {
      this.$refs.passwordForm.validate(valid => {
        if (valid) {
          this.z_put("access/api/home/changePassWord", {}, {
            params: {
              password: this.passwordForm.pw,
              newPassword: this.passwordForm.npw
            },
            loading: this.$refs.passwordForm
          }
          ).then(res => {
            this.$message({
              message: "修改成功",
              type: "success",
              duration: 1000
            });
            this.$refs.passwordForm.resetFields();
            this.innerVisible = false;
          }).catch(res => {
            this.$alert("修改失败！" + res.msg, "提示", {
              confirmButtonText: "确定",
              type: "error"
            });
          });
        }
      });
    }
  }
}
</script>